export const siteInfo = {
  name: 'PERTUBUHAN INSAN PERWIRA PULAU PINANG',
  shortName: 'INSAN PERWIRA',
  tagline: 'Empowering Youth, Building Futures',
  email: 'insanperwirapenang@gmail.com',
  phone: '+60 4-123 4567',
  address: 'NO.1-4, JALAN KAMPUNG GAJAH, 12200 BUTTERWORTH, PULAU PINANG',
  registrationNumber: 'PPM-012-10-0609313',
};

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Activities', href: '/activities' },
  { label: 'Courses', href: '/courses' },
  { label: 'Mentorship', href: '/mentorship' },
  { label: 'Outreach', href: '/outreach' },
  { label: 'Donate', href: '/donation' },
];

export const heroContent = {
  title: 'Empowering Pulau Pinang\'s Youth Through Education & Community',
  subtitle: 'We provide computer skills training, mentorship, and outreach programs that transform lives and build brighter futures for the youth of Butterworth and beyond.',
  cta: 'Support Our Mission',
  secondaryCta: 'Learn More',
};

export const aboutContent = {
  title: 'Who We Are',
  subtitle: 'Since our founding, PERTUBUHAN INSAN PERWIRA PULAU PINANG has been dedicated to uplifting underprivileged youth in the Butterworth community.',
  description: 'We believe every young person deserves access to quality education, meaningful mentorship, and opportunities to thrive. Through our computer skills courses, mentorship programs, and community outreach initiatives, we are building a generation of empowered, skilled, and confident youth ready to shape Malaysia\'s future.',
  stats: [
    { value: '500+', label: 'Youth Empowered' },
    { value: '8+', label: 'Years of Service' },
    { value: '30+', label: 'Community Programs' },
    { value: '50+', label: 'Volunteer Mentors' },
  ],
};

export const programHighlights = [
  {
    title: 'Computer Skills Courses',
    subtitle: 'Digital literacy for the future',
    description: 'Hands-on training in essential computer skills, from basic digital literacy to advanced programming, preparing youth for the modern workforce.',
    icon: 'ri-computer-line',
    href: '/courses',
    imageQuery: 'Modern%20computer%20lab%20with%20young%20Malaysian%20students%20learning%20coding%20on%20laptops%2C%20bright%20classroom%20with%20natural%20light%2C%20diverse%20youth%20collaborating%2C%20warm%20and%20inspiring%20atmosphere%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography',
  },
  {
    title: 'Mentorship Programs',
    subtitle: 'Guidance that changes lives',
    description: 'One-on-one and group mentorship connecting youth with experienced professionals who provide career guidance, life skills, and personal development support.',
    icon: 'ri-user-heart-line',
    href: '/mentorship',
    imageQuery: 'Mentor%20and%20young%20student%20having%20meaningful%20conversation%20in%20modern%20community%20center%2C%20warm%20natural%20lighting%2C%20diverse%20Malaysian%20participants%2C%20genuine%20connection%2C%20inspirational%20setting%2C%20clean%20composition',
  },
  {
    title: 'Community Outreach',
    subtitle: 'Reaching every corner',
    description: 'Mobile programs and community events that bring resources directly to underserved neighborhoods, ensuring no youth is left behind.',
    icon: 'ri-community-line',
    href: '/outreach',
    imageQuery: 'Community%20outreach%20event%20in%20Malaysian%20neighborhood%20with%20volunteers%20distributing%20educational%20materials%2C%20colorful%20banners%2C%20families%20gathering%2C%20warm%20tropical%20sunlight%2C%20joyful%20atmosphere%2C%20documentary%20style%20photography',
  },
];

export const testimonials = [
  {
    name: 'Ahmad Faizal',
    role: 'Program Graduate, 2024',
    text: 'The computer skills course completely changed my career path. I went from having zero digital knowledge to landing a job as a junior web developer. INSAN PERWIRA gave me the confidence and skills I needed.',
  },
  {
    name: 'Nurul Huda',
    role: 'Mentorship Participant',
    text: 'My mentor didn\'t just teach me professional skills — she helped me believe in myself. The mentorship program at INSAN PERWIRA is truly life-changing for young people like me who needed guidance.',
  },
  {
    name: 'Rajesh Kumar',
    role: 'Community Volunteer',
    text: 'Seeing the impact of the outreach programs firsthand has been incredible. The joy on the children\'s faces when they learn something new is priceless. I\'m proud to be part of this organization.',
  },
  {
    name: 'Siti Mariam',
    role: 'Parent of Program Participant',
    text: 'My daughter joined the computer course last year and her transformation has been amazing. She\'s more confident, more focused, and she even helps other kids in our neighborhood with their studies now.',
  },
  {
    name: 'Lim Wei Jie',
    role: 'Course Graduate, 2023',
    text: 'Before INSAN PERWIRA, I didn\'t know what career path to take. The mentorship and technical training opened doors I never knew existed. Today I\'m pursuing my diploma in IT, all thanks to this program.',
  },
];

export const activities = [
  {
    title: 'Youth Digital Bootcamp 2026',
    date: '15 July 2026',
    location: 'Butterworth Community Hall',
    category: 'Workshop',
    description: 'A 3-day intensive bootcamp covering web development, digital marketing, and basic cybersecurity for youth aged 16-25.',
    imageQuery: 'Youth%20digital%20bootcamp%20workshop%20in%20community%20hall%2C%20students%20working%20on%20laptops%2C%20energetic%20learning%20environment%2C%20modern%20classroom%20setup%2C%20Malaysian%20youth%2C%20bright%20natural%20lighting',
  },
  {
    title: 'Community Clean-Up & Tech Day',
    date: '2 August 2026',
    location: 'Kampung Gajah Area',
    category: 'Community',
    description: 'Combined environmental clean-up with free tech consultation booths for local residents. Volunteers needed!',
    imageQuery: 'Community%20cleanup%20event%20in%20Malaysian%20village%2C%20volunteers%20picking%20up%20litter%2C%20tech%20booth%20set%20up%20nearby%2C%20sunny%20day%2C%20community%20spirit%2C%20green%20surroundings',
  },
  {
    title: 'Mentorship Open Day',
    date: '20 September 2026',
    location: 'INSAN PERWIRA Center',
    category: 'Networking',
    description: 'Meet our mentors, learn about the program, and sign up for the next mentorship cycle. Open to all youth in Pulau Pinang.',
    imageQuery: 'Open%20day%20networking%20event%20with%20mentors%20and%20youth%20in%20modern%20center%2C%20name%20tags%2C%20coffee%20and%20snacks%2C%20friendly%20conversations%2C%20warm%20indoor%20lighting%2C%20professional%20yet%20casual',
  },
];

export const donationContent = {
  title: 'Make a Difference Today',
  subtitle: 'Your contribution helps us provide free computer courses, mentorship programs, and community outreach to youth who need it most. Every ringgit counts.',
  cta: 'Get Involved',
};

export const footerLinks = {
  programs: [
    { label: 'Computer Courses', href: '/courses' },
    { label: 'Mentorship', href: '/mentorship' },
    { label: 'Community Outreach', href: '/outreach' },
    { label: 'Activities', href: '/activities' },
  ],
  organization: [
    { label: 'About Us', href: '/' },
    { label: 'Donate', href: '/donation' },
    { label: 'Contact', href: '#contact' },
    { label: 'Volunteer', href: '#volunteer' },
  ],
  connect: [
    { label: 'Facebook', href: '#' },
    { label: 'Instagram', href: '#' },
    { label: 'Twitter', href: '#' },
    { label: 'YouTube', href: '#' },
  ],
};